exports.Types_Enums = {
    ONE_TWO_S_RULE: {main: "1", sub: "2s"},
    TWO_TWO_S_RULE: {main: "2", sub: "2s"},
    ONE_THREE_S_RULE: {main: "1", sub: "3s"},
    R_FOUR_S_RULE: {main: "R", sub: "4s"},
    FOUR_ONE_S_RULE: {main: "4", sub: "1s"},
    TEN_X_RULE: {main: "10", sub: "x"},
}

exports.One_Two_S_Rule = function(results, std, mean) {
    // A Point exceeds plus 2-SD or minus 2-SD

    // let violations = 0;
    // for(let i = 0; i < results.length; i++){
    //     if(results[i].Result > (std * 2) || results[i].Result < (-std * 2)){
    //         violations++;
    //     }
    // }
    // return violations;

    let violations = 0;
    for(let i = 0; i < results.length; i++){
        if(results[i].Result > (mean + (std * 2)) || results[i].Result < (mean - (std * 2))){
            violations++;
        }
    }
    return violations;
}

exports.Two_Two_S_Rule = function(results, std, mean) {
    // 2 consective points exceeds plus 2-SD or minus 2-SD
    let violations = 0;
    for(let i = 0; i < results.length - 1; i++){
        console.log("Result ---> 34", results[i].Result)
        console.log("Pos 2 SD ---> 35", (mean + (std * 2)))
        console.log("Neg 2 SD ---> 36", (mean - (std * 2)))
        if((results[i].Result > (mean + (std * 2)) && results[i + 1].Result > (mean + (std * 2))) || (results[i].Result < (mean - (std * 2)) && results[i + 1].Result < (mean - (std * 2)))){
            violations++;
        }
    }
    return violations;
}

exports.One_Three_S_Rule = function(results, std, mean) {
    // A Point exceeds plus 3-SD or minus 3-SD
    let violations = 0;
    for(let i = 0; i < results.length; i++){
        if(results[i].Result > (mean + (std * 3)) || results[i].Result < (mean - (std * 3))){
            violations++;
        }
    }
    return violations;
}

exports.R_Four_S_Rule = function(results, std, mean) {
    // (first point exceeds plus 2-SD and second point minus 2-SD) or (first point exceeds minus 2-SD and second point plus 2-SD)
    let violations = 0;
    for(let i = 0; i < results.length-1; i++){
        if((results[i].Result > (mean + (std * 2)) && results[i + 1].Result < (mean - (std * 2))) || (results[i].Result < (mean - (std * 2)) && results[i + 1].Result > (mean + (std * 2)))) {
            violations++;
        }
    }
    return violations;
}

exports.Four_One_S_Rule = function(results, std, mean) {
    // Four Consective on plus 1-SD or minus 1-SD
    let violations = 0;
    let slice = [];
    let flags = 0;
    let IsPositive = false;
    if(results.length < 4){
        return flags;
    }
    for(let i = 0; i < results.length - 3; i++) {
        if(results.length > 4){
            slice = results.slice(i, i + 4);
        }
        else{
            slice = results;
        }
        console.log(slice);
        let j = 0;
        for(; j < slice.length; j++){
            if(slice[j].Result > (mean + std)) {
                if(!IsPositive){
                    violations = 0;
                }
                violations++;
                IsPositive = true;
            }
            else if(slice[j].Result < (mean - std)){
                if(IsPositive){
                    violations = 0;
                }
                violations++;
                IsPositive = false;
            }
            else {
                violations = 0;
                IsPositive = false;
                break;
            }
        }
        if(violations === 4){
            flags++;
            violations = 0;
        }
        else{
            violations = 0;
        }
    }
    return flags;
    // while(result_length > 3) {
    //     console.log("here 1")
    //     for(let j = 0; j < results.length; j++) {
    //         if(results[i + j] > std) { 
    //             console.log("here 1.5")
    //             if(!(j < 3)) {
    //                 console.log("here 2")
    //                 i += j;
    //                 result_length -= j;
    //                 violations.push(true);
    //                 break;
    //             }
    //         }
    //         else {
    //             console.log("here 3", j);
    //             i += j + 1;
    //             result_length -= j + 1;
    //             console.log("here 4", result_length);
    //             break;
    //         }
    //     }
    // }
}

exports.Ten_X_Rule = function(results, mean) {
    let violations = 0;
    let slice = [];
    let flags = 0;
    let IsPositive = false;
    if(results.length < 10){
        return flags;
    }
    for(let i = 0; i < results.length - 9; i++) {
        if(results.length > 10){
            slice = results.slice(i, i + 10);
        }
        else{
            slice = results;
        }
        console.log(slice);
        let j = 0;
        for(; j < slice.length; j++){
            console.log("Result 136", slice[j].Result)
            console.log("Mean 137", mean)
            if(slice[j].Result > mean) {
                if(!IsPositive){
                    violations = 0;
                }
                violations++;
                IsPositive = true;
            }
            else if(slice[j].Result < mean){
                if(IsPositive){
                    violations = 0;
                }
                violations++;
                IsPositive = false;
                console.log("violations 151", violations)
            }
            else {
                violations = 0;
                IsPositive = false;
                break;
            }
        }
        if(violations === 10){
            flags++;
            violations = 0;
        }
        else {
            violations = 0;
        }
    }
    return flags;
    // let violations = [];
    // let result_length = results.length;
    // console.log("length --> ",result_length)
    // let i = 0;
    // while(result_length > 9) {
    //     console.log("here 1")
    //     for(let j = 0; j < results.length; j++) {
    //         if(results[i + j] > mean) { 
    //             console.log("here 1.5")
    //             if(!(j < 9)) {
    //                 console.log("here 2")
    //                 i += j;
    //                 result_length -= j;
    //                 violations.push(true);
    //                 break;
    //             }
    //         }
    //         else {
    //             console.log("here 3", j);
    //             i += j + 1;
    //             result_length -= j + 1;
    //             console.log("here 4", result_length);
    //             break;
    //         }
    //     }
    // }
    // return violations;
}